export const receitas = 'receitas';
export const boletos = 'boletos';
export const ticketMedio = 'ticketMedio';
export const valorMedioPorCupom = 'valorMedioPorCupom';
export const mediaItensPorCupom = 'mediaItensPorCupom';
export const boletoUm = 'BoletoUm';

export const evolucaoDeReceitas = 'EvolucaoDeReceitas';
export const evolucaoDeBoletos = 'EvolucaoDeBoletos';
export const qntMediaDeItensPorBoleto = 'QntMediaDeItensPorBoleto';
export const valorMedioPorBoleto = 'ValorMedioPorBoleto';
export const taxaConversao = 'TaxaConversao';
export const valorMedioPorItens = 'ValorMedioPorItens';

export const RankingLoja = 'RankingLoja';
export const RankingVendedor = 'RankingVendedor';
